import { render, staticRenderFns } from "./switch-defaultValue-editor.vue?vue&type=template&id=98bc90ba&scoped=true&"
import script from "./switch-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./switch-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bc90ba",
  null
  
)

export default component.exports